import { AlertTriangle } from "lucide-react";

import { COMPUTING_OPACITY_PULSE_CLASS } from "../../statusStyles";
import { useCellContentDialogContext } from "../cell-content-dialog-context";

import { CellStatus, PENDING_CELL_STATUSES } from "@/queries/smart-tables/types";

export default function CellContentStatusBar() {
  const { effectiveStatus: status } = useCellContentDialogContext();

  if (PENDING_CELL_STATUSES.has(status)) {
    return (
      <div className="flex items-center gap-2 border-b bg-blue-50 px-5 py-2 text-sm text-blue-700 dark:bg-blue-950/30 dark:text-blue-300">
        <span className={`inline-flex items-center gap-2 ${COMPUTING_OPACITY_PULSE_CLASS}`}>
          <span className="h-2 w-2 flex-shrink-0 rounded-full bg-blue-500/80" />
          <span>Computing…</span>
        </span>
      </div>
    );
  }

  if (status === CellStatus.STALE) {
    return (
      <div className="flex items-center gap-2 border-b bg-amber-50 px-5 py-2 text-sm text-amber-700 dark:bg-amber-950/30 dark:text-amber-300">
        <AlertTriangle className="h-4 w-4 flex-shrink-0" />
        <span>Inputs changed since last run. Re-run to get an updated value.</span>
      </div>
    );
  }

  return null;
}
